/*
 * 品牌参数全部在 public/runtime-env.js 里配置，这里只按访问域名选出当前品牌：
 * brands 里 domains 包含访问域名的那个，都没命中用 defaultBrand；common 是各品牌共用的字段。
 */
const runtimeConfig = window.__RUNTIME_CONFIG__ || {};
const brands = runtimeConfig.brands || {};

const pickBrand = () => {
  const host = window.location.hostname
  return Object.keys(brands).find(name => (brands[name].domains || []).some(d => host.includes(d)))
    || runtimeConfig.defaultBrand
}

const brand = pickBrand()

export default Object.assign({ brand }, runtimeConfig.common, brands[brand])
